/**
 * @generated SignedSource<<180fc3e292f99989abb82e7da6af9677>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type hubHomeContent_AtlassianHubHome_HubInfo$data = {
  readonly helpCenterById: {
    readonly __typename: "HelpCenter";
    readonly allPages: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"actionBar_AtlassianHubHome">;
    } | null | undefined>;
    readonly hoistedProjectKey: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly type: HelpCenterType | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"layoutEditor_AtlassianHubHome">;
  readonly " $fragmentType": "hubHomeContent_AtlassianHubHome_HubInfo";
};
export type hubHomeContent_AtlassianHubHome_HubInfo$key = {
  readonly " $data"?: hubHomeContent_AtlassianHubHome_HubInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"hubHomeContent_AtlassianHubHome_HubInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hubAri"
    }
  ],
  "kind": "Fragment",
  "name": "hubHomeContent_AtlassianHubHome_HubInfo",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "helpCenterAri",
          "variableName": "hubAri"
        }
      ],
      "kind": "LinkedField",
      "name": "helpCenterById",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "kind": "ScalarField",
              "name": "hoistedProjectKey"
            },
            {
              "kind": "ScalarField",
              "name": "slug"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "allPages",
                "concreteType": "HelpCenterPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "actionBar_AtlassianHubHome"
                  }
                ]
              },
              "action": "THROW",
              "path": "helpCenterById.allPages"
            }
          ],
          "type": "HelpCenter"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ],
          "type": "QueryError"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "layoutEditor_AtlassianHubHome"
    }
  ],
  "type": "HelpCenterQueryApi"
};

(node as any).hash = "b27e89bd7af7d4c0f0cfc6b5f32adf04";

export default node;
